import { useState } from 'react';
import { useAuth } from '../../../contexts/AuthContext';

export const useAuthModal = () => {
  const { error, clearError } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handleSocialAuth = async (authMethod, onSuccess) => {
    setIsLoading(true);
    clearError();
    
    try {
      await authMethod();
      onSuccess?.();
    } catch (err) {
      // Error is already set in AuthContext
    } finally {
      setIsLoading(false);
    }
  };

  const resetLoading = () => {
    setIsLoading(false);
  };

  return {
    isLoading,
    setIsLoading,
    error,
    clearError,
    handleSocialAuth,
    resetLoading
  };
};

